module.exports = __webpack_public_path__ + "static/rpa-8c2b64de1d6ec562e223ac4c1b24cab5.svg";